import { toast } from 'sonner'
import { ConfirmDialog } from '@/components/confirm-dialog'
import { notifyError } from '@/components/notify'
import type { Schedule } from '@/types/api'
import { useDeleteSchedule } from '../api'

export function DeleteScheduleDialog({ schedule, onOpenChange, onDeleted }: { schedule: Schedule | null; onOpenChange: (open: boolean) => void; onDeleted?: () => void }) {
  const del = useDeleteSchedule()
  return (
    <ConfirmDialog
      open={!!schedule}
      onOpenChange={onOpenChange}
      title={`Delete “${schedule?.name ?? ''}”?`}
      description="Screens stop playing it at their next sync and fall back to whatever else is scheduled, then their default content. The channel or slideshow itself is not deleted."
      confirmLabel="Delete schedule"
      destructive
      onConfirm={async () => {
        if (!schedule) return
        try {
          await del.mutateAsync(schedule.id)
          toast.success('Schedule deleted', { description: schedule.name })
          onDeleted?.()
        } catch (e) {
          notifyError(e)
          throw e
        }
      }}
    />
  )
}
